<div ngbDropdown class="kt-header__topbar-item kt-header__topbar-item--langs">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper"
		[ngbTooltip]="'SHARED.LANGUAGES.CHANGE-LANGUAGE' | translate">
		<span class="kt-header__topbar-icon" [ngClass]="{ 'kt-header__topbar-icon--brand' : iconType === 'brand' }">
			<img class="" src="{{(availableLanguages | activeLanguage)?.flag}}" alt="" />
		</span>
	</div>
	<div ngbDropdownMenu aria-labelledby="language-menu"
		class="dropdown-menu dropdown-menu-fit dropdown-menu-anim dropdown-menu-top-unround">
		<ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
			<ng-container *ngFor="let language of availableLanguages">
				<li ngbDropdownToggle ngbDropdownItem class="kt-nav__item"
					[ngClass]="{'dropdown-item': false, 'kt-nav__item--active': language.isActive}">
					<a href="javascript:;" (click)="setLanguage(language.lang)"
						[ngClass]="{'kt-nav__link--active': language.isActive, 'disabled': !supportedLanguages.includes(language.lang)}"
						class="kt-nav__link" placement="left"
						[ngbTooltip]="supportedLanguages.includes(language.lang) ? '' : 'We\'re working on it.. :-)'">
						<span class="kt-nav__link-icon">
							<img src="{{language.flag}}">
						</span>
						<span class="kt-nav__link-text">{{language.name}}</span>
					</a>
				</li>
			</ng-container>
		</ul>
	</div>
</div>